import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../components/Formulario"; 
import { createGrupo } from "../../../api/grupoApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type TipoLancamento = {
  value: string;
  label: string;
};

const AdicionarGrupo: React.FC = () => {
  const [nomeGrupo, setNomeGrupo] = useState<string>("");
  const [grupoTipoLancamento, setGrupoTipoLancamento] = useState<TipoLancamento | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const tipoLancamentoOpcoes: TipoLancamento[] = [
    { value: "Tipo_Completo", label: "Tipo Completo" },
    { value: "Tipo_Parcial", label: "Tipo Parcial" },
  ];

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      const formData = new FormData();
      formData.append("nome_grupo", nomeGrupo);
      
      if (grupoTipoLancamento) {
        formData.append("grupo_tipo_lancamento", grupoTipoLancamento.value);
      }

      await createGrupo(token, formData);
      toast.success("Grupo criado com sucesso!");
      navigate("/grupo");
    } catch (error) {
      toast.error("Erro ao adicionar grupo!");
      console.error("Erro ao adicionar grupo:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const fields: FormField[] = [
    {
      label: "Nome do Grupo",
      type: "text",
      value: nomeGrupo,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeGrupo(e.target.value),
    },
    {
      label: "Tipo de Lançamento",
      type: "autocomplete",
      value: grupoTipoLancamento,
      required: false, 
      onChangeAutocomplete: (event, newValue) => {
        setGrupoTipoLancamento(newValue);
      },
      options: tipoLancamentoOpcoes,
      getOptionLabel: (option: TipoLancamento) => option.label,
    },
  ];

  return (
    <Formulario
      title="Adicionar Grupo"
      fields={fields}
      onSubmit={handleSubmit}
      loading={loading}
      onBack={handleBack}
    />
  );
};

export default AdicionarGrupo;